import styled from 'styled-components'

import { theme } from '@/styles/theme';

import {
  Table,
  Thead,
  Tr,
  Th,
} from '@/components/elements/Table'

import type { StockSituation } from '@/types/stockSituation'

type Props = {
  items: StockSituation[]
}

export const StatusSharesTable = ({ items }: Props) => {
  const list = items[0].stockTotalList;

  return (
    <Wrapper>
      {/* <Table id="irp-highlight-table-dividend2" /> */}
      <section>
      <Table>
          <Thead>
            {
              list.map((item,index)=>(
                <Tr key={index}>
                  <Th color={'tertiary'} textAlign="left">{item.stockName_en}</Th>
                  <Th color={'quaternary'} textAlign="right">{formatNumber(item.stockValue)}</Th>
                </Tr>
              ))
            }
          </Thead>
        </Table>
      </section>
    </Wrapper>
  )
}
const formatNumber = (num:number) => num.toLocaleString();

const Wrapper = styled.div`
  overflow-y: auto;
    border-collapse: separate;
    width: 100%;

     thead {
      > tr:first-of-type > th:first-of-type {
        position: sticky;
        left: 0;
        border-left: 1px solid ${theme.colors.tableBorder};
      }

      > tr:first-of-type > th {
        border-top: 1px solid ${theme.colors.tableBorder};
      }

      > tr > th {
        word-break: keep-all;
      }
    }

     tbody {
      > tr > th {
        border-left: 1px solid ${theme.colors.tableBorder};
      }

      > tr > th:first-of-type {
        position: sticky;
        left: 0;
      }

      > tr > td:last-of-type {
        border-right: 1px solid ${theme.colors.tableBorder};
        
      }

      @media screen and (max-width: 1047px) {
        > tr > th {
          min-width: 30vw;
        }
      }
    }

    th {
      padding: 14px 14px 16px 14px;
      vertical-align: middle;
      line-height: 1.2;
      border-right: 1px solid ${theme.colors.tableBorder};
      border-bottom: 1px solid ${theme.colors.tableBorder};
      font-size: 16px;

      &[data-align='center'] {
        text-align: center;
      }

      &[data-align='right'] {
        text-align: right;
      }

      &[data-align='left'] {
        text-align: left;
      }

      &[data-hasborder='false'] {
        border-right: none;
      }

      @media screen and (max-width: 1047px) {
        padding: 10px 12px 12px 12px;
        font-size: 15px;
      }

      &[data-bgcolor='primary'] {
        background: ${theme.colors.th.primary};
      }

      &[data-bgcolor='secondary'] {
        background: ${theme.colors.th.secondary};
      }

      &[data-bgcolor='quaternary'] {
        background: ${theme.colors.th.quaternary};
      }

      &[data-bgcolor='darkest'] {
        background: ${theme.colors.th.darkest};
      }
    }

    td {
      text-align: right;
      background: ${theme.colors.td.default};
      font-size: 16px;
      
      padding: 14px 14px 16px 14px;
      vertical-align: middle;
      line-height: 1.2;
      border-right: 1px solid ${theme.colors.tableBorder};
      
      border-bottom: 1px solid ${theme.colors.tableBorder};
      

      &[data-align='center'] {
        text-align: center;
      }

      &[data-align='right'] {
        text-align: right;
      }

      &[data-align='left'] {
        text-align: left;
      }

      &[data-hasborder='false'] {
        border-right: none;
      }

      @media screen and (max-width: 1047px) {
        padding: 10px 12px 12px 12px;
        font-size: 15px;
      }

      &[data-bgcolor='primary'] {
        background: ${theme.colors.th.primary};
      }

      &[data-bgcolor='secondary'] {
        background: ${theme.colors.th.secondary};
      }

      &[data-bgcolor='tertiary'] {
        background: ${theme.colors.th.tertiary};
      }

      &[data-bgcolor='darkest'] {
        background: ${theme.colors.th.darkest};
      }
    }
`

